import { useEffect, useRef } from 'react';
import { DevRoomScene } from '@bracesDesigner/devRoom/devRoomScene.ts';

interface Props {}

export function DevRoomCanvas({}: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const sceneRef = useRef<DevRoomScene>(undefined);

  useEffect(() => {
    if (!containerRef.current) return;

    const scene = new DevRoomScene(containerRef.current);
    sceneRef.current = scene;
    scene.init();

    return () => {
      scene.dispose();
      sceneRef.current = undefined;
    };
  }, []);

  return <div ref={containerRef} className={'w-full h-full'} />;
}
